function createApiFactory(factory, instance) {
  if ("id" in factory) {
    return {
      api: factory,
      deps: {},
      factory: () => instance
    };
  }
  return factory;
}

export { createApiFactory };
//# sourceMappingURL=helpers.esm.js.map
